// updates user location every 24 hours if permission granted

import Cookies from "js-cookie"

import { getNavigatorGeoLocationCoordinates } from "../utils/geo"

export default function initLocationTrackerUpdater() {
  const { locationTrackerCookieName: cookieName } =
    window.NaturkartanConfig || {}

  if (!cookieName) return

  const cookie = Cookies.get(cookieName)

  if (cookie && cookie != `deny`) {
    const timeCookieName = `${cookieName}:time`
    const timeCookie = parseInt(Cookies.get(timeCookieName) || 0)
    const hourDiff = (Date.now() - timeCookie) / (1000 * 3600)

    if (hourDiff > 24) {
      getNavigatorGeoLocationCoordinates()
        .then(({ lat, lng }) => {
          Cookies.set(cookieName, `${lat},${lng}`, { expires: 365 })
          Cookies.set(`${this.cookieNameValue}:time`, Date.now(), {
            expires: 365,
          })
        })
        .catch(() => {})
    }
  }
}
